const ArquivoService = {
    upload: function(arquivo) {
        return fetch(`/api/upload/file`, {
            method: "POST",
            body: arquivo,
          }).then(async (r) => {
            if (!r.ok) {
                // console.log(r)
                return r.json();
            }
            return r.json();
        });
    },
};

export default ArquivoService;
